import { useEffect, useState } from 'react';
import { getHasServiceTypes } from '../api/buildingServicesApi';

/**
 * Whether the instance has service types configured, or null while loading.
 * Gates features that only make sense with services (the analysis page).
 */
export function useHasServiceTypes(): boolean | null {
    const [hasServiceTypes, setHasServiceTypes] = useState<boolean | null>(null);

    useEffect(() => {
        let cancelled = false;
        getHasServiceTypes().then(value => {
            if (!cancelled) setHasServiceTypes(value);
        });
        return () => { cancelled = true; };
    }, []);

    return hasServiceTypes;
}
